import { render, staticRenderFns } from "./ModalListPatientInRoom.vue?vue&type=template&id=7992a466&scoped=true"
import script from "./ModalListPatientInRoom.vue?vue&type=script&lang=js"
export * from "./ModalListPatientInRoom.vue?vue&type=script&lang=js"
import style0 from "./ModalListPatientInRoom.vue?vue&type=style&index=0&id=7992a466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7992a466",
  null
  
)

export default component.exports